<template>
    <i class="user-status m-r-smd" :class="{ 'is-active': status, 'is-current': current }" />
</template>

<script>
export default {
    name: 'UserStatus',

    props: {
        status: {
            type: Boolean,
            default: false,
        },

        current: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'resources/scss/toolbox.scss';

.user-status {
    border: 2px solid $primary;
    border-radius: 100%;
    display: inline-block;
    height: 16px;
    width: 16px;

    &.is-active {
        background: $primary;
    }

    &.is-current {
        border-color: $white;

        &.is-active {
            background: $white;
        }
    }
}
</style>
